{
  "tabs": {
    "chat": "Xat",
    "reminders": "Recordatoris",
    "calendar": "Calendari",
    "settings": "Configuració"
  },
  "common": {
    "cancel": "Cancel·lar",
    "save": "Desa",
    "confirm": "Confirma",
    "delete": "Elimina",
    "back": "Enrere",
    "close": "Tanca",
    "edit": "Edita",
    "search": "Cerca",
    "all": "Tots",
    "loading": "Carregant...",
    "error": "Hi ha hagut un error",
    "notFound": "No s'ha trobat",
    "tryAgain": "Si us plau, torna-ho a provar",
    "retry": "Torna-ho a provar",
    "undo": "Desfés",
    "pullToRefresh": "Desplaça per actualitzar",
    "justNow": "ara mateix"
  },
  "auth": {
    "welcome": "Benvingut a FishMemory",
    "tagline": "El teu assistent de recordatoris de WhatsApp, ara a la butxaca.",
    "subtitle": "El teu assistent de recordatoris de WhatsApp, ara a la butxaca.",
    "phoneLabel": "El teu número de WhatsApp",
    "phoneHint": "T'enviarem un codi de verificació per WhatsApp",
    "invalidPhone": "Si us plau, introdueix un número de telèfon vàlid",
    "continue": "Continua",
    "enterPhone": "Introdueix el teu número de WhatsApp",
    "phonePlaceholder": "Número de telèfon",
    "sendCode": "Envia codi",
    "verifyTitle": "Verifica el teu número",
    "otpSentTo": "S'ha enviat un codi de 6 dígits a {{phone}} per WhatsApp",
    "enterFullCode": "Si us plau, introdueix els 6 dígits",
    "invalidOtp": "Codi invàlid. Torna-ho a provar.",
    "otpFailed": "No s'ha pogut enviar el codi. Torna-ho a provar.",
    "otpResent": "Codi reenviat",
    "resendIn": "Reenvia en {{seconds}}s",
    "resendCode": "Reenvia codi",
    "enterOtp": "Introdueix el codi enviat al teu WhatsApp",
    "verify": "Verifica",
    "resend": "Reenvia codi",
    "wrongNumber": "Número incorrecte?",
    "backToPhone": "Torna al telèfon",
    "editPhone": "Edita número",
    "error": "Error",
    "setupTitle": "Configurem-ho",
    "setupSubtitle": "Sempre podràs canviar-ho després a Configuració",
    "namePlaceholder": "El teu nom",
    "letsGo": "Acaba la configuració",
    "skipForNow": "Salta-ho ara"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Escriu un missatge...",
    "inputPlaceholder": "Escriu un missatge...",
    "typing": "FishMemory està escrivint...",
    "online": "Connectat",
    "connecting": "Connectant...",
    "reconnecting": "Reconnectant...",
    "offline": "Desconnectat",
    "empty": "Comença una conversa",
    "emptyHint": "Crea recordatoris, consulta la teva agenda o demana ajuda.",
    "emptyAction": "Envia un recordatori de mostra",
    "actions": "Accions de xat",
    "keep": "Conserva missatges",
    "clearTitle": "Neteja xat",
    "clearConfirm": "Eliminar tots els missatges d'aquest dispositiu? No es pot desfer.",
    "clear": "Neteja xat",
    "optionSelected": "Seleccionat: {{label}}",
    "sendingSelection": "Enviant...",
    "connectionLost": "Reconnectant..."
  },
  "reminders": {
    "title": "Els meus recordatoris",
    "active": "Actius",
    "today": "Avui",
    "thisWeek": "Aquesta setmana",
    "history": "Historial",
    "items": "elements",
    "emptyTitle": "Encara no hi ha recordatoris",
    "emptySubtitle": "Crea'n un des del xat i apareixerà aquí.",
    "emptyAction": "Obre el xat",
    "filterActive": "Actius",
    "filterToday": "Avui",
    "filterWeek": "Aquesta setmana",
    "filterHistory": "Historial",
    "emptyState": "Encara no hi ha recordatoris. Comença a xatejar!",
    "swipeDone": "Fet",
    "swipeSnooze": "Posposa",
    "swipeDelete": "Elimina",
    "search": "Cerca recordatoris...",
    "upcoming": "Properament",
    "completed": "Completats",
    "overdue": "Vencuts",
    "tomorrow": "Demà",
    "synced": "Sincronitzat {{value}}",
    "swipeHint": "Desplaça un recordatori per més accions",
    "noResults": "Cap recordatori coincideix amb la cerca",
    "noResultsHint": "Prova una altra paraula clau o esborra la cerca",
    "deleteAllFailed": "No s'han pogut eliminar tots els recordatoris"
  },
  "calendar": {
    "title": "Calendari",
    "today": "Avui",
    "tomorrow": "Demà",
    "completed": "fet",
    "noEvents": "No hi ha res programat",
    "noEventsSubtitle": "Tria una data per veure recordatoris i esdeveniments del calendari.",
    "googleEvent": "Google Calendar",
    "legendActive": "Actiu",
    "legendRecurring": "Recurrent",
    "legendDone": "Fet",
    "legendGoogle": "Google",
    "previousMonth": "Mes anterior",
    "nextMonth": "Mes següent",
    "previousYear": "Any anterior",
    "nextYear": "Any següent",
    "goToToday": "Ves a avui",
    "all": "Tots",
    "active": "Actius",
    "done": "Fets",
    "paused": "Pausats"
  },
  "settings": {
    "title": "Configuració",
    "profile": "Perfil",
    "name": "Nom visible",
    "enterName": "Introdueix el teu nom",
    "language": "Idioma",
    "uiLanguage": "Idioma de l'app",
    "uiLanguageHelp": "Canvia la interfície, etiquetes del calendari i direcció només en aquest dispositiu.",
    "serverLanguage": "Idioma del xat",
    "serverLanguageHelp": "Canvia l'idioma de les respostes del servidor i missatges de recordatori per al teu compte.",
    "timezone": "Zona horària",
    "currentTimezone": "Zona horària actual",
    "timezoneHelp": "Tots els horaris dels recordatoris es mostren segons aquesta zona horària.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Desa zona horària",
    "timezoneSaved": "Zona horària actualitzada",
    "detect": "Detecta",
    "detectFailed": "No s'ha pogut detectar la zona horària",
    "autoDetect": "Detecta automàticament per GPS",
    "notifications": "Notificacions",
    "notificationsHelp": "Els recordatoris de seguiment controlen alertes repetides després d'entregar un recordatori. Els permisos de notificació es gestionen a la configuració del telèfon.",
    "pushEnabled": "Notificacions Push",
    "autoDoneOnFire": "Marca automàticament com a fet quan s'activa",
    "autoDoneOnFireDesc": "Si està desactivat, els recordatoris romanen actius fins que els marquis com a fets.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Connectat",
    "googleDisconnected": "No connectat",
    "googleConnectedHelp": "Els nous recordatoris es poden sincronitzar automàticament amb el calendari.",
    "googleDisconnectedHelp": "Connecta Google Calendar per mantenir els recordatoris i esdeveniments alineats.",
    "googleConnectFailed": "No s'ha pogut connectar Google Calendar",
    "connected": "Connectat",
    "disconnected": "No connectat",
    "connect": "Connecta",
    "disconnect": "Desconnecta",
    "autoSync": "Sincronització automàtica de nous recordatoris",
    "autosync": "Sincronització automàtica de nous recordatoris",
    "subscription": "Subscripció",
    "trialUsed": "Prova: {{used}}/{{total}} usada",
    "trialStatus": "Prova disponible",
    "activeStatus": "Subscripció activa",
    "expiredStatus": "Subscripció expirada",
    "unsubscribedStatus": "No subscrit",
    "about": "Sobre",
    "version": "Versió",
    "logout": "Tanca sessió",
    "logoutTitle": "Tanca sessió",
    "logoutConfirm": "Estàs segur que vols tancar sessió?",
    "noName": "Sense nom establert",
    "serverConnection": "Connexió al servidor",
    "serverUrl": "URL del servidor",
    "serverEdit": "Edita",
    "saveReconnect": "Desa i reconnecta",
    "resetDefault": "Restableix per defecte",
    "invalidServerUrlTitle": "URL del servidor invàlid",
    "invalidServerUrlMessage": "Introdueix una URL vàlida http o https, per exemple https://example.com",
    "uiLanguageChangeFailed": "No s'ha pogut canviar l'idioma de l'app. Torna-ho a provar.",
    "serverLanguageChangeFailed": "No s'ha pogut canviar l'idioma del xat. Torna-ho a provar.",
    "timezoneChangeFailed": "No s'ha pogut canviar la zona horària. Torna-ho a provar.",
    "autoSyncChangeFailed": "No s'ha pogut actualitzar la sincronització automàtica. Torna-ho a provar.",
    "nameChangeFailed": "No s'ha pogut actualitzar el nom visible. Torna-ho a provar.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Detalls del recordatori",
    "editTime": "Edita hora",
    "rename": "Canvia nom",
    "snooze": "Posposa",
    "snooze15": "Posposa 15 minuts",
    "pause": "Pausa",
    "pauseReminder": "Pausa recordatori",
    "resume": "Repren",
    "resumeReminder": "Repren recordatori",
    "skip": "Saltar següent",
    "skipOccurrence": "Saltar aquesta ocurrència",
    "syncGoogle": "Sincronitza amb Google",
    "delete": "Elimina",
    "deleteTitle": "Elimina recordatori",
    "deleteConfirm": "Aquest recordatori s'eliminarà permanentment.",
    "deleteRecurringTitle": "Elimina recordatori recurrent",
    "deleteRecurringMessage": "Vols saltar aquesta ocurrència o eliminar tota la sèrie?",
    "deleteThisOccurrence": "Saltar aquesta ocurrència",
    "deleteEntireSeries": "Elimina tota la sèrie",
    "done": "Fet",
    "markDone": "Marca com a fet",
    "undo": "Restaura",
    "undoPrompt": "Vols que torni a estar actiu? Restaura'l ara.",
    "recurring": "Recurrent",
    "nextRun": "Proper execució",
    "oneTime": "Únic",
    "pending": "Pendent",
    "sent": "Enviat",
    "paused": "Pausat",
    "active": "Actiu",
    "snoozed": "Posposat",
    "localTime": "Mostrat en hora local",
    "recurrence": "Recurrència",
    "created": "Creat",
    "tags": "Etiquetes",
    "fireCount": "Vegades activat",
    "actions": "Accions",
    "none": "Cap",
    "snoozeFailed": "No s'ha pogut posposar el recordatori",
    "pauseFailed": "No s'ha pogut pausar el recordatori",
    "resumeFailed": "No s'ha pogut reprendre el recordatori",
    "skipFailed": "No s'ha pogut saltar el recordatori",
    "doneFailed": "No s'ha pogut marcar el recordatori com a fet",
    "undoFailed": "No s'ha pogut restaurar l'estat del recordatori",
    "deleteFailed": "No s'ha pogut eliminar el recordatori",
    "rescheduleTitle": "Vols reprogramar?",
    "rescheduleMsg": "Aquest recordatori està vençut. Vols reprogramar-lo?",
    "reschedule15": "En 15 minuts",
    "reschedule60": "En 1 hora",
    "keepOverdue": "Deixa-ho com està"
  },
  "onboarding": {
    "slide1Title": "Benvingut a FishMemory",
    "slide1Sub": "El teu assistent personal de recordatoris — impulsat per WhatsApp i fet per a la teva butxaca.",
    "slide2Title": "Només xateja naturalment",
    "slide2Sub": "Escriu recordatoris com penses: \"Recorda'm trucar a la mare demà a les 3pm\" — nosaltres ens encarreguem de la resta.",
    "slide3Title": "No et perdis res",
    "slide3Sub": "Rep notificacions puntuals, organitza amb etiquetes i mantén-te al dia de tot el que importa.",
    "getStarted": "Comença",
    "next": "Següent",
    "firstReminderTitle": "Crea el teu primer recordatori!",
    "firstReminderHint": "Prova a escriure:",
    "firstReminderExample": "Recorda'm beure aigua demà a les 9 AM",
    "gotIt": "Entès!",
    "notifRationaleTitle": "Sigues puntual",
    "notifRationaleBody": "FishMemory necessita notificacions per recordar-te a temps. Només rebràs alertes dels recordatoris que creïs.",
    "notifRationaleAllow": "Activa les notificacions",
    "notifRationaleLater": "Potser més tard",
    "swipeHint": "Desplaça a la dreta per accions ràpides →",
    "calendarDragHint": "Arrossega per expandir ↕"
  }
}
